import uri from 'urijs';

const getPostUrl = (topology, paths) =>
  uri
    .joinPaths(uri(topology.baseUrl).pathname(), topology.postPagePath, ...paths)
    .absoluteTo(topology.baseUrl)
    .toString();

export default getPostUrl;
